export const toKebabCase = (word: string | undefined) => {
    return word?.toLowerCase().replace(/\s/g || '\xa0', '-') ?? undefined;
};
